// Generated by purs version 0.15.15
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var union = /* #__PURE__ */ Data_Map_Internal.union(Data_Ord.ordInt);
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var lookup1 = /* #__PURE__ */ Data_Map_Internal.lookup(Data_Ord.ordInt);
var insert1 = /* #__PURE__ */ Data_Map_Internal.insert(Data_Ord.ordInt);
var Key = function (x) {
    return x;
};
var Vault = function (x) {
    return x;
};
var unsafeToAny = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var unsafeFromAny = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var semigroupVault = {
    append: function (v) {
        return function (v1) {
            return union(v)(v1);
        };
    }
};
var nextKey = /* #__PURE__ */ Effect_Unsafe.unsafePerformEffect(/* #__PURE__ */ Effect_Ref["new"](0));
var newKey = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect)(Key)(/* #__PURE__ */ Effect_Ref.modify(function (v) {
    return v + 1 | 0;
})(nextKey));
var keyIndex = function (v) {
    return v;
};
var lookup = function (k) {
    return function (v) {
        return map(unsafeFromAny(k))(lookup1(keyIndex(k))(v));
    };
};
var insert = function (k) {
    return function (v) {
        return function (v1) {
            return insert1(keyIndex(k))(unsafeToAny(k)(v))(v1);
        };
    };
};
var empty = Data_Map_Internal.empty;
var monoidVault = {
    mempty: empty,
    Semigroup0: function () {
        return semigroupVault;
    }
};
var singleton = function (k) {
    return function (v) {
        return insert(k)(v)(empty);
    };
};
export {
    newKey,
    empty,
    insert,
    lookup,
    singleton,
    semigroupVault,
    monoidVault
};
